export const updateState = ({ state, otherState = {} }) => {
	return {
		...state,
		...otherState,
		lastModifiedOn: new Date().toISOString(),
	};
};
